'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeLeadForm = exports.leadFormAction = exports.LEAD_FORM = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.doInitializeLeadForm = doInitializeLeadForm;
exports.doSubmitLeadForm = doSubmitLeadForm;
exports.watchLeadFormSagas = watchLeadFormSagas;

var _reactIntl = require('react-intl');

var _reduxForm = require('redux-form');

var _reduxFormSaga = require('redux-form-saga');

var _effects = require('redux-saga/effects');

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _deep = require('helpers/deep');

var _object = require('helpers/object');

var ObjectUtil = _interopRequireWildcard(_object);

var _multitrack = require('helpers/multitrack');

var _userTypeCookie = require('helpers/userTypeCookie');

var _locale = require('redux/modules/locale');

var _helpers = require('redux/saga/helpers');

var _Consent = require('components/Consent/Consent.saga');

var _ApiError = require('components/Errors/ApiError');

var _LeadGenForm = require('features/LeadGenForm/LeadGenForm.saga');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doInitializeLeadForm),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doSubmitLeadForm),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchLeadFormSagas);

var messages = (0, _reactIntl.defineMessages)({
  alreadyMember: {
    id: 'signup.lead.already-member',
    defaultMessage: 'Looks like you already started creating a ClassPass account with this email address in the past. Please <a href="{loginLink}">log in</a> to complete your purchase.',
    hasHtml: true
  },
  invalidEmail: {
    id: 'signup.lead.invalid-email',
    defaultMessage: 'Please check your email address for misspellings.'
  }
});

var LEAD_FORM = exports.LEAD_FORM = 'signup-card-lead';
var leadFormAction = exports.leadFormAction = (0, _reduxFormSaga.createFormAction)(LEAD_FORM);

var initializeLeadForm = exports.initializeLeadForm = function initializeLeadForm(hiddenFields) {
  return {
    type: 'INITIALIZE_' + LEAD_FORM,
    hiddenFields: hiddenFields
  };
};

function doInitializeLeadForm(client, _ref) {
  var hiddenFields = _ref.hiddenFields;
  var consent;
  return _regenerator2.default.wrap(function doInitializeLeadForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_Consent.loadAccountCreationConsent, client);

        case 2:
          consent = _context.sent;
          _context.next = 5;
          return (0, _effects.put)((0, _reduxForm.initialize)(LEAD_FORM, (0, _extends3.default)({}, ObjectUtil.pick(['marketing', 'marketingDisclaimer', 'marketingDefault'], consent), hiddenFields)));

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function doSubmitLeadForm(client, _ref2) {
  var form = _ref2.payload;
  var locale, activeLocation, errorCode, emailError, generalError, loginLink;
  return _regenerator2.default.wrap(function doSubmitLeadForm$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!form.marketing) {
            _context2.next = 47;
            break;
          }

          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(_locale.selectUserLocale);

        case 4:
          locale = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_helpers.getUserLocation, client);

        case 7:
          activeLocation = _context2.sent;
          _context2.next = 10;
          return (0, _effects.call)(_LeadGenForm.createLead, client, form.email, { locale: locale, location: activeLocation });

        case 10:
          _context2.next = 12;
          return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'Membership Purchase Lead Creation');

        case 12:
          _context2.next = 47;
          break;

        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2['catch'](1);
          errorCode = (0, _deep.deepExtract)('code', _context2.t0);

          if (!(_LeadGenForm.CODE_BY_ERROR.ALREADY_ON_WAITLIST === errorCode)) {
            _context2.next = 22;
            break;
          }

          _context2.next = 20;
          return (0, _effects.call)(_userTypeCookie.set, 'lead');

        case 20:
          _context2.next = 47;
          break;

        case 22:
          emailError = void 0;
          generalError = void 0;

          if (!(_LeadGenForm.CODE_BY_ERROR.ALREADY_MEMBER === errorCode)) {
            _context2.next = 33;
            break;
          }

          _context2.next = 27;
          return (0, _effects.call)(_userTypeCookie.set, 'registered');

        case 27:
          loginLink = '/login?returnTo=' + form.resumeSignupLink;

          emailError = (0, _extends3.default)({}, messages.alreadyMember, { values: { loginLink: loginLink } });
          _context2.next = 31;
          return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'Membership Purchase Lead Creation Error', 'Already member');

        case 31:
          _context2.next = 44;
          break;

        case 33:
          if (!(_LeadGenForm.CODE_BY_ERROR.INVALID_EMAIL === errorCode)) {
            _context2.next = 39;
            break;
          }

          emailError = messages.invalidEmail;
          _context2.next = 37;
          return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'Membership Purchase Lead Creation Error', 'Invalid email');

        case 37:
          _context2.next = 44;
          break;

        case 39:
          generalError = _ApiError.GENERIC_ERROR;
          _context2.next = 42;
          return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'Membership Purchase Lead Creation Error', 'Unexpected error');

        case 42:
          _context2.next = 44;
          return (0, _effects.spawn)(logger.error, 'Failed to create lead during signup', _context2.t0);

        case 44:
          _context2.next = 46;
          return (0, _effects.put)(leadFormAction.failure(new _reduxForm.SubmissionError({
            _error: generalError,
            email: emailError
          })));

        case 46:
          return _context2.abrupt('return', _context2.sent);

        case 47:
          _context2.next = 49;
          return (0, _effects.put)(leadFormAction.success(ObjectUtil.pick(['email', 'marketing', 'marketingDisclaimer', 'marketingDefault'], form)));

        case 49:
          return _context2.abrupt('return', _context2.sent);

        case 50:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[1, 14]]);
}

function watchLeadFormSagas(client) {
  return _regenerator2.default.wrap(function watchLeadFormSagas$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, initializeLeadForm().type, doInitializeLeadForm, client);

        case 2:
          _context3.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, leadFormAction.REQUEST, doSubmitLeadForm, client);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}